import { render, staticRenderFns } from "./potentialSupplierManageList.vue?vue&type=template&id=f8211aa2"
import script from "./potentialSupplierManageList.vue?vue&type=script&lang=js"
export * from "./potentialSupplierManageList.vue?vue&type=script&lang=js"
import style0 from "./potentialSupplierManageList.vue?vue&type=style&index=0&id=f8211aa2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8211aa2')) {
      api.createRecord('f8211aa2', component.options)
    } else {
      api.reload('f8211aa2', component.options)
    }
    module.hot.accept("./potentialSupplierManageList.vue?vue&type=template&id=f8211aa2", function () {
      api.rerender('f8211aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/supplierManage/potentialSupplierManageList.vue"
export default component.exports